import { useEffect, useState } from "react"
import { RegisterPay } from "src/pages/reservaciones/inicio/components/RegisterPay/RegisterPay"
import { v4 as uuid } from "uuid"

import "./AsignacionReservacionesTabPago.css"
import LabelFlexLines from "./sections/LabelFlexLines"
import {
    EstadosReservas,
    GetReservacionesTableQuery,
    useGetReservacionByIdQuery,
} from "src/gql/schema"
import { PrimaryButton } from "src/pages/home/room-detail/sections/elements/Elements"
import { minus, sum } from "src/shared/helpers/calculator"
import Pago from "./sections/Pago/Pago"
import Descuento from "./sections/Descuento/Descuento"
import { useDate } from "src/shared/hooks/useDate"
import { formatCurrency } from "src/shared/hooks/formatCurrency"
import { useIVA } from "src/shared/hooks/useIVA"
import { formatText } from "src/shared/hooks/formatTextOpcions"
import { getCardLabel } from "src/shared/sections/payment/helpers/card"
import { isVisibleCardOrReference } from "src/shared/sections/payment/Payment.helpers"
import { ItemMultiplePayment } from "src/pages/home/room-detail/sections/items/Items"
import { useProfile } from "src/shared/hooks/useProfile"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"
import { RoleNames } from "src/shared/hooks/useAuth"
import DescriptionDetailTarifas from "src/shared/components/data-display/description-detail-tarifas/DescriptionDetailTarifas"
import { useDesgloseReservasTarifas } from "src/shared/hooks/useMotorTarifas"
import DrawerAccordion from "src/shared/components/data-display/drawer-accordion/DrawerAccordion"

const AsignacionReservacionesTabPago = ({
    sentReservaD,
}: {
    sentReservaD: GetReservacionesTableQuery["reservas"][0]
}) => {
    const { data, refetch } = useGetReservacionByIdQuery({
        variables: {
            id: sentReservaD.reserva_id,
        },
    })

    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()
    const [reservaActualizada, setReservaActualizada] = useState<any>()
    const { rolName } = useProfile()
    const isMaintenance = rolName === RoleNames.mantenimiento
    const { UTCStringToLocalDate, setHHMMSS, diffDays } = useDate()
    const { nowHotel } = useFormatDate()

    useEffect(() => {
        setReservaActualizada(data?.reservas[0])
    }, [data])

    const [isNoShow, setIsNoShow] = useState(false)
    const [totalPorPagar, settotalPorPagar] = useState(0)

    useEffect(() => {
        setIsNoShow(
            nowHotel.getTime() >
                setHHMMSS({
                    startDate: UTCStringToLocalDate(sentReservaD.fecha_salida),
                    newHour: sentReservaD?.reservas_tarifas?.slice().sort((a, b) => new Date(b.fecha_fin).getTime() - new Date(a.fecha_fin).getTime())?.[0]?.tarifa?.hora_checkin || "",
                }).getTime() +
                    60 * 1000
        )
        const allPagos = [
            ...(reservaActualizada?.pagos || []),
            ...(reservaActualizada?.renta?.pagos || []),
        ].filter((pago, index, self) => self.findIndex((p) => p.pago_id === pago.pago_id) === index)
        settotalPorPagar(
            minus(
                reservaActualizada?.total || 0,
                sum(
                    allPagos.flatMap((p) =>
                        p.detalles_pago?.map((detallePago) => detallePago?.subtotal || 0) || [0]
                    )
                )
            )
        )
    }, [reservaActualizada])

    const { getIVA } = useIVA()
    const [isRegistrarPagoModalOpen, setisRegistrarPagoModalOpen] = useState(false)

    const { desglose_tarifas_reservas } = useDesgloseReservasTarifas(reservaActualizada?.reservas_tarifas)

    const allPagos = [
        ...(reservaActualizada?.pagos || []),
        ...(reservaActualizada?.renta?.pagos || []),
    ].filter((pago, index, self) => self.findIndex((p) => p.pago_id === pago.pago_id) === index)

    const diasAlojamiento =
        diffDays(
            UTCStringToLocalDate(reservaActualizada?.fecha_entrada),
            UTCStringToLocalDate(reservaActualizada?.fecha_salida)
        ) || 1
    
    const descuentoAplicado = reservaActualizada?.descuento_aplicado ?? sentReservaD?.descuento_aplicado

    const descuentos = [
        ...(descuentoAplicado
            ? [
                {
                    tipo: "Estancia" as const,
                    monto: descuentoAplicado.data_descuento?.monto_calculado || 0,
                    fecha: UTCStringToLocalDate(descuentoAplicado.fecha_registro),
                    nombre: descuentoAplicado.descuento?.nombre || "",
                },
            ]
            : []),
        ...(reservaActualizada?.extras
            ?.filter((extra) => extra?.descuento_aplicado)
            ?.map((extra) => ({
                tipo: "Extras" as const,
                monto:
                    extra.descuento_aplicado?.data_descuento?.monto_calculado || 0,
                fecha: UTCStringToLocalDate(
                    extra.descuento_aplicado?.fecha_registro
                ),
                nombre:
                    extra.descuento_aplicado?.descuento?.nombre || "",
            })) || []),
    ]

    const totalDescuento = sum(
        descuentos.map((descuento) => descuento.monto)
    )
        
    const totalEstancia = reservaActualizada?.subtotales?.total_habitacion || 0
    const totalPersonasExtra =  reservaActualizada?.subtotales?.total_personas_extra || 0
    const totalExperiencias =
        reservaActualizada?.subtotales?.total_experiencias || 0
    const totalImpuestos = getIVA(totalEstancia + totalPersonasExtra + totalExperiencias)
    const totalCuenta = sum([reservaActualizada?.total || 0, totalDescuento])

    const hasPersonasExtra = (reservaActualizada?.personas_extras || 0) > 0
    const hasExperiencias = totalExperiencias > 0
    const hasPagos = allPagos.some(
        (p) => p?.detalles_pago && p.detalles_pago.length > 0
    )
    const hasDescuentos = descuentos.length > 0

    return (
        <div className="asignacion__reservaciones__drawer__tab__pay">
            <div
                className="asignacion__reservaciones__drawer__tab__pay__top"
                style={{
                    height: isNoShow || totalPorPagar <= 0 ? "calc(100dvh - 450px)" : "calc(100dvh - 490px)",
                }}
            >
                <DrawerAccordion
                    title="Resumen de compra"
                    isEmpty={false}
                    emptyDescription="No hay descuentos registrados"
                    emptyIcon={"priceTag"}
                >
                    <DescriptionDetailTarifas
                        icon="BedFilled"
                        label="Estancia y tarifas"
                        style={{ width: "100%", padding: "12px 0" }}
                        tarifas={desglose_tarifas_reservas.map((d) => ({
                            nombre: d.nombre,
                            subtotal: d.subtotal,
                            dias: d.dias,
                            hospedaje: d.registros_finales.map((r) => ({
                                rango: r.rango,
                                costo: r.precio_unitario,
                            })),
                        }))}
                    />

                    {reservaActualizada?.personas_extras > 0 && (
                        <DescriptionDetailTarifas
                            icon="UserParentFill"
                            label="Personas extras"
                            style={{ width: "100%", padding: "12px 0" }}
                            tarifas={desglose_tarifas_reservas
                                .filter((d) =>
                                    d.registros.some((r) => (r.costo_persona_extra ?? 0) > 0)
                                )
                                .map((d) => {
                                    const personas = reservaActualizada?.personas_extras ?? 0

                                    const subtotal = d.registros.reduce((acc, r) => {
                                        return acc + ((r.costo_persona_extra ?? 0) * personas * r.noches)
                                    }, 0)

                                    return {
                                        nombre: d.nombre,
                                        subtotal,
                                        dias: d.dias,
                                        hospedaje: d.registros
                                            .filter((r) => (r.costo_persona_extra ?? 0) > 0)
                                            .map((r) => ({
                                                personas,
                                                costo: (r.costo_persona_extra ?? 0) * personas * r.noches,
                                                costo_individual: r.costo_persona_extra,
                                            })),
                                    }
                                })}
                        />
                    )}
                    {!!reservaActualizada?.experiencias_reserva?.length && (
                        <ItemMultiplePayment
                            showAmounts={true}
                            icon={"star"}
                            label={"Experiencias"}
                            style={{ width: "100%", padding: "12px 0" }}
                            className="detalle-h-items__multiple--experience"
                            labelClass="detalle-h-items__multiple__text--experience"
                            payments={
                                reservaActualizada?.experiencias_reserva?.map((s) => ({
                                    label: s.experiencia?.nombre || "",
                                    amount: s.total ?? 0,
                                })) || []
                            }
                        />
                    )}
                </DrawerAccordion>
                <DrawerAccordion
                    title="Pagos registrados"
                    isEmpty={!hasPagos}
                    emptyDescription="No hay pagos registrados"
                    emptyIcon={"CoinsFill"}
                >
                    <div className="asignacion__reservaciones__drawer__tab__pay__info">
                        {isRegistrarPagoModalOpen && (
                            <RegisterPay
                                id={reservaActualizada.reserva_id || ""}
                                onClose={() => {
                                    refetch()
                                    setisRegistrarPagoModalOpen(false)
                                }}
                            />
                        )}
                        {allPagos.map((p) => {
                            return p?.detalles_pago?.map((detallePago) => {
                                return (
                                    <Pago
                                        key={uuid()}
                                        date={UTCStringToLocalDate(p.fecha_pago)}
                                        isCard={isVisibleCardOrReference(detallePago?.tipo_pago)}
                                        payType={formatText(detallePago.tipo_pago)}
                                        total={detallePago.subtotal}
                                        ultimos_digitos={getCardLabel(detallePago)}
                                        parcialPay={detallePago.subtotal !== reservaActualizada?.total}
                                        type={detallePago.tipo_pago || ""}
                                    />
                                )
                            })
                        })}
                    </div>
                </DrawerAccordion>

                <DrawerAccordion
                    title="Descuentos"
                    isEmpty={!hasDescuentos}
                    emptyDescription="No hay descuentos registrados"
                    emptyIcon={"priceTag"}
                >
                    {descuentos.map((descuento) => (
                        <Descuento
                            key={uuid()}
                            monto={descuento.monto}
                            fecha={descuento.fecha}
                            nombre={descuento.nombre}
                            tipo={descuento.tipo}
                        />
                    ))}
                </DrawerAccordion>
            </div>

            <div className="asignacion__reservaciones__drawer__tab__pay__total">
                <div className="asignacion__reservaciones__drawer__tab__pay__total__divider"></div>
                <LabelFlexLines
                    label1={`Estancia (${diasAlojamiento} ${diasAlojamiento > 1 ? 'noches' : 'noche'})`}
                    value1={formatCurrency(totalEstancia)}
                />
                { hasPersonasExtra && (
                    <LabelFlexLines
                        label1={`Personas extra (${reservaActualizada?.personas_extras})`}
                        value1={formatCurrency(totalPersonasExtra)}
                        style={{
                            marginTop: "-10px",
                        }}
                    />
                )}
                { hasExperiencias && (
                    <LabelFlexLines
                        label1={`Experiencias (${reservaActualizada?.experiencias_reserva?.length})`}
                        value1={formatCurrency(totalExperiencias)}
                        style={{
                            marginTop: "-10px",
                        }}
                    />
                )}

                <LabelFlexLines
                    label1="Impuestos"
                    value1={formatCurrency(totalImpuestos)}
                    style={{
                        marginTop: "-10px",
                        fontWeight: 400,
                    }}
                />
                <LabelFlexLines
                    label1="Total de cuenta"
                    value1={formatCurrency(totalCuenta)}
                    style={{
                        marginTop: "-10px",
                    }}
                />
                
                <div className="asignacion__reservaciones__drawer__tab__pay__total__divider"></div>
                <LabelFlexLines
                    label1="Descuentos"
                    value1={`${totalDescuento > 0 ? "-" : ""}${formatCurrency(totalDescuento)}`}
                    style={{
                        marginBottom: "-10px",
                        fontWeight: 400,
                    }}
                />
                <LabelFlexLines
                    label1="Total pagado"
                    value1={(() => {
                        const total = sum(
                            allPagos.flatMap(
                                (p) => p.detalles_pago?.map((d) => d?.subtotal || 0) || [0]
                            )
                        )

                        return `${total > 0 ? "-" : ""}${formatCurrency(total)}`
                    })()}
                    style={{
                        marginBottom: "-10px",
                        fontWeight: 400,
                    }}
                />
                {reservaActualizada?.estado === EstadosReservas.Cancelada ? (
                    <LabelFlexLines
                        label1="Devolución"
                        value1={formatCurrency(reservaActualizada?.monto_devuelto_cancelacion || 0)}
                        style={{ fontWeight: 700, fontSize: "20px" }}
                    />
                ) : (
                    <LabelFlexLines
                        label1="Por pagar"
                        value1={formatCurrency(Math.max(0, totalPorPagar))}
                        style={{ fontWeight: 700, fontSize: "20px" }}
                    />
                )}
                {!isMaintenance && !isNoShow && totalPorPagar > 0 && reservaActualizada?.estado !== EstadosReservas.Cancelada && (
                    <PrimaryButton onClick={validateIsColabActive(() => setisRegistrarPagoModalOpen(true))} text="Registrar pago" />
                )}
            </div>
            {InactiveModal}
        </div>
    )
}

export default AsignacionReservacionesTabPago
